import { render, staticRenderFns } from "./home_bargain.vue?vue&type=template&id=786f4a04&scoped=true"
import script from "./home_bargain.vue?vue&type=script&lang=js"
export * from "./home_bargain.vue?vue&type=script&lang=js"
import style0 from "./home_bargain.vue?vue&type=style&index=0&id=786f4a04&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786f4a04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\java\\project\\kaixinshequ-java\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('786f4a04')) {
      api.createRecord('786f4a04', component.options)
    } else {
      api.reload('786f4a04', component.options)
    }
    module.hot.accept("./home_bargain.vue?vue&type=template&id=786f4a04&scoped=true", function () {
      api.rerender('786f4a04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobilePage/home_bargain.vue"
export default component.exports